import React from "react";
import { translate } from "../../translate";
import AnimatedModal from "../AnimatedModal";
import { STRINGS } from "../../strings";
import { AppButton } from "../Generic/AppButton";
import { default as WomanWarning } from "/public/assets/woman-warning.svg?react";
import Flex from "../Generic/Flex";

export interface PromptVerifyMissedVisitModalProps {
  isOpen: boolean;
  onClickClose: () => void;
  onClickConfirm: () => void;
}

export function PromptVerifyMissedVisitModal(props: PromptVerifyMissedVisitModalProps) {
  const actions = (
    <Flex direction="column" gap={4}>
      <AppButton color="primary" onClick={props.onClickConfirm}>
        {translate(STRINGS.YES_I_AM_SURE)}
      </AppButton>
      <AppButton color="primary" variant="outline" onClick={props.onClickClose}>
        {translate(STRINGS.CANCEL)}
      </AppButton>
    </Flex>
  );
  return (
    <AnimatedModal
      headline={translate(STRINGS.ARE_YOU_SURE)}
      message={translate(STRINGS.THIS_WILL_MARK_THE_VISIT_AS_MISSED)}
      animation={<WomanWarning width={"300px"} height={"400px"} />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onClickClose}
    />
  );
}
